<template lang="pug">
  v-form(class="organizations-users-edit")
    h2(
      v-if="!xsDevice"
      class="title-32px bold mb-2"
    ) {{ $t('Change user role') }}
    p(
      v-if="!xsDevice"
      class="text-14px light mb-8"
    ) {{ $t('You are going to change the role of the selected user in the system. The selected role will determine the level of access and user capabilities in the system') }}
    ValidationObserver(ref="form")
      ValidationProvider(
        :name="$t('Email')"
        rules="required|email"
        v-slot="{ errors }"
        mode="lazy"
      )
        v-text-field(
          v-model="dataForm.email"
          :label="$t('Email')"
          :error-messages="errors"
          readonly
          filled
        )
      ValidationProvider(
        :name="$t('Role in system')"
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
      )
        v-select(
          v-model="dataForm.role"
          :items="userRoles"
          :label="$t('Role in system')"
          :error-messages="errors"
          :menuProps="{ bottom: true, offsetY: true }"
          filled
        )
    div(class="organizations-users-edit__actions")
      v-btn(
        height="48"
        @click="closeModal(false)"
      ) {{ $t('Cancel') }}
      v-btn(
        :loading="isLoading"
        class="main-button"
        @click="submit"
      ) {{ $t('Save') }}
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import TOrmFields from '~/components/templates/orm/t-orm-fields.vue'
import OrganizationUsers from '~/modules/organizations/models/OrganizationUsers'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'FormOrganizationsUsersEdit',
  components: {
    TOrmFields,
    ValidationProvider
  },
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    closeDrawer: {
      type: Function,
      default: () => {}
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      dataForm: {
        email: '',
        role: ''
      }
    }
  },
  computed: {
    userRoles() {
      return OrganizationUsers.userRoles.filter(
        item => item.value !== OrganizationUsers.ROLES.OWNER
      )
    }
  },
  created() {
    this.dataForm.email = this.user.email
    this.dataForm.role = this.user.role
  },
  methods: {
    closeWindow(value) {
      // todo: component does not depend on drawer or model
      if (this.xsDevice) {
        this.closeDrawer(value)
      } else {
        this.closeModal(value)
      }
    },
    async submit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return
      }
      if (this.dataForm.role === this.user.role) {
        this.closeWindow(false)
        return
      }
      try {
        this.isLoading = true
        const payload = {
          ...this.dataForm,
          notifyIncoming: this.dataForm.role === OrganizationUsers.ROLES.ACCOUNTANT ? false : this._.get(this.user, 'notifyIncoming', false),
          notifyApproved: this._.get(this.user, 'notifyApproved', false),
          notifyComments: this._.get(this.user, 'notifyComments', false),
          notifyRejected: this._.get(this.user, 'notifyRejected', false),
          notifyReminders: this._.get(this.user, 'notifyReminders', false),
          notifySigned: this._.get(this.user, 'notifySigned', false)
        }
        await this.$store.dispatch('organizationusers/update', {
          id: this.user.id,
          payload
        })
        this.closeWindow(true)
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss">
.organizations-users-edit {
  &__actions {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'md')) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: none;
    }
  }
}
</style>
